import * as React from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {BI_SCHEMA} from '../../services/biLogger/biEvents';
import {useIsMobile} from '../../services/effects/useIsMobile';
import {trackSelector} from '../../store/selectors';
import {useBiLogger} from '../BiProvider/withBiLogger';
import {DownloadLinks} from '../DownloadLinks/DownloadLinks';
import {Subtitle} from '../ui/Subtitle/Subtitle';
import {IOuter} from './FreeDownload.types';

export const FreeDownload: React.FunctionComponent<IOuter> = ({entityType, freeDownloadLinks}) => {
  const {t} = useTranslation();
  const biLogger = useBiLogger();
  const track = useSelector(trackSelector);

  const onDownloadClick = (format: string) => {
    biLogger.log(BI_SCHEMA.player.downloadPage.download.clicked, {
      type: entityType,
      format,
      trackID: track ? String(track.id) : undefined,
    });
  };
  const isMobile = useIsMobile();
  const mobileSubtitles = {
    track: 'mgw.getTrack',
    album: 'mgw.getAlbum',
    single: 'mgw.getSingle',
  };

  const subtitle = t(isMobile ? mobileSubtitles[entityType] : 'mgw.downloadForFree');

  return (
    <div data-hook="freeDownload">
      <Subtitle dataHook="subtitle-header">{subtitle}</Subtitle>
      <DownloadLinks downloadLinks={freeDownloadLinks} onDownloadClick={onDownloadClick} />
    </div>
  );
};

FreeDownload.displayName = 'FreeDownload';
